
export const getImageUrlWithSas = async (Url) => {
  try {


    const response = await fetch(
      `https://hirecrap-backend-gcg3e8cmcgfwe6ef.westus2-01.azurewebsites.net/api/candidates/${Url}?expiryMinutes=60`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch resume access URL");
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error("Error fetching resume URL:", error);
    throw error;
  }
};